import React, { useState } from 'react';
import './CommentForm.css';

function CommentForm({ comment, rating, onCommentChange, onRatingChange, onSubmit }) {
    const [hoverRating, setHoverRating] = useState(0);

    return (
        <form onSubmit={onSubmit}>
            <div className="rating">
                {[1, 2, 3, 4, 5].map((star) => (
                    <span
                        key={star}
                        className={`star ${hoverRating >= star || rating >= star ? 'filled' : ''}`}
                        onClick={() => onRatingChange(star)}
                        onMouseEnter={() => setHoverRating(star)}
                        onMouseLeave={() => setHoverRating(0)}
                    >
                        &#9733;
                    </span>
                ))}
            </div>
            <label htmlFor="comment">Comment:</label>
            <textarea
                id="comment"
                name="comment"
                value={comment}
                onChange={onCommentChange}
                required
            />
            <button type="submit" className="submit-button">Submit</button>
        </form>
    );
}

export default CommentForm;